// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"557":"5abc5b16","879":"14789ac0","924":"58d26a66"}[chunkId] + ".chunk.js";
};